class ErrorModalController {
  $onInit() {
    $('#errorModal').on('hidden.bs.modal', () => {
      this.onClosed();
    });
  }
}

export default ErrorModalController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/withdrawal/component/error.modal.controller.js